import RepositoryFactory from '@/services/repository-factory';

const ordersRepository = RepositoryFactory.get('orders');
const state = () => ({
  repository: ordersRepository,
  error: null,
});

export default state;
